import { render, staticRenderFns } from "./customSwal.vue?vue&type=template&id=6639e989&"
import script from "./customSwal.vue?vue&type=script&lang=js&"
export * from "./customSwal.vue?vue&type=script&lang=js&"
import style0 from "./customSwal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports